import axios from 'axios';
import { createAction } from 'redux-actions';
import { get_service_endpoint } from 'ServiceEndpoints';
import { flash } from './CommonActions';

const GET_MARKETING_SOURCES = createAction('GET_MARKETING_SOURCES');
const CREATE_MARKETING_SOURCE = createAction('CREATE_MARKETING_SOURCE');

const marketingSourceEndpoint = get_service_endpoint('fabric');

export const getMarketingSources = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${marketingSourceEndpoint}/marketing/get-all-source`, { params });
    dispatch(GET_MARKETING_SOURCES(res.data.data));
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to fetch marketing sources',
      }),
    );
  }
};

export const createMarketingSource = (requestData) => async (dispatch) => {
  try {
    const res = await axios.post(`${marketingSourceEndpoint}/marketing/create-source`, requestData);
    if (res?.data?.data?.success === false) {
      throw {
        response: { data: { message: res?.data?.data?.message || 'Failed to Create source' } },
      };
    }
    dispatch(CREATE_MARKETING_SOURCE(res.data.data));
    return res.data;
  } catch (err) {
    dispatch(
      flash({
        message: err.response?.data?.message || 'Failed to create source',
      }),
    );
    throw err;
  }
};
